import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Intervento } from '../../types'
import { PartialWithId } from '@inmagik/react-crud/dist/types'

export default function ModalConfirmIntervento({
  isOpen,
  toggle,
  title,
  body,
  intervento,
  onConfirm,
}: {
  isOpen: boolean
  toggle: () => void
  title: string
  body: string | JSX.Element
  intervento: Intervento
  onConfirm: (intervento: Intervento) => void
}) {
  const [note, setNote] = useState(intervento?.note_intervento_invalido ?? '')
  return (
    <Modal
      show={isOpen}
      onHide={toggle}
      centered
      backdropClassName="backdrop-high"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{body}</div>
        {intervento.esito_riesame === 'invalido' && (
          <div className="form-group mt-3">
            <label className="label-m text-body-secondary">Note</label>
            <textarea
              className="form-control"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <button className="btn btn-outline-secondary" onClick={toggle}>
          Annulla
        </button>
        <button
          className="btn btn-secondary text-white"
          onClick={() => {
            onConfirm({ ...intervento, note })
            toggle()
          }}
        >
          Conferma
        </button>
      </Modal.Footer>
    </Modal>
  )
}
